import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { es, enGB, fr, de } from "date-fns/locale";
import { useTranslation } from "react-i18next";

const LOCALES = { es, en: enGB, fr, de };

export const AvailabilityCalendar = ({ bookedDates, range, onSelect, closed = false }) => {
  const { i18n } = useTranslation();
  const locale = LOCALES[(i18n.language || "es").slice(0, 2)] || es;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // De momento la reserva online solo está abierta para julio y agosto
  const outsideSummer = (d) => d.getMonth() !== 6 && d.getMonth() !== 7;
  // Solo reservable hasta el verano del año que viene
  const maxDate = new Date(today.getFullYear() + 1, 7, 31);
  // Abrir el calendario directamente en el primer julio reservable:
  // todo lo demás está cerrado, no tiene sentido empezar en el mes actual
  const openStart = new Date(today.getFullYear() + (today.getMonth() > 7 ? 1 : 0), 6, 1);
  // Con las reservas cerradas, todos los días aparecen bloqueados
  const allDays = () => true;

  return (
    <div data-testid="availability-calendar" className="overflow-x-auto">
      <DayPicker
        mode="range"
        selected={range}
        onSelect={onSelect}
        numberOfMonths={1}
        locale={locale}
        defaultMonth={range?.from || openStart}
        startMonth={openStart}
        endMonth={maxDate}
        disabled={closed ? [allDays] : [{ before: today }, { after: maxDate }, outsideSummer, ...bookedDates]}
        modifiers={{ booked: closed ? [allDays] : bookedDates }}
        modifiersClassNames={{ booked: "rdp-day_booked" }}
        showOutsideDays={false}
      />
    </div>
  );
};
